import { VyberHranyDialog } from "@/components/dielec/VyberHranyDialog";

/**
 * Stav 4 hrán pre dielec (X1 predok, X2 zadok, Y1 horná, Y2 spodná).
 *
 * Kreslí ich `HranyLista` (štvorriadkový editor `HranyEditor` odišiel
 * v KOLE 201 — nikde sa nevykresľoval).
 *
 * Mapovanie na API:
 * - enabled=true,  id=null  → ``hrana_*_auto=true,  hrana_*_id=null``
 *   (auto = backend derivuje cez EdgeAutoMapper zo slotu)
 * - enabled=true,  id=UUID  → ``hrana_*_auto=false, hrana_*_id=UUID``
 *   (manual)
 * - enabled=false → ``hrana_*_auto=false, hrana_*_id=null`` (žiadna)
 */
export interface EdgeState {
  id: string | null;
  auto: boolean;
}

export interface HranyState {
  x1: EdgeState;
  x2: EdgeState;
  y1: EdgeState;
  y2: EdgeState;
}

export function defaultHranyState(): HranyState {
  return {
    x1: { id: null, auto: true },
    x2: { id: null, auto: true },
    y1: { id: null, auto: true },
    y2: { id: null, auto: true },
  };
}

/**
 * Výber hrany z celého cenníka bez materiálu (hromadná úprava, cenovka,
 * tabuľka hrán slotu). Od KOLA 201 je to `VyberHranyDialog` so šírkou
 * a hrúbkou pásky v rozbaľovačkách.
 */
export function HranaPickerDialog({
  open,
  currentId,
  onClose,
  onSelect,
  nadpis = "Vybrať ABS hranu",
}: {
  open: boolean;
  currentId: string | null;
  onClose: () => void;
  onSelect: (id: string) => void;
  nadpis?: string;
}): JSX.Element {
  return (
    <VyberHranyDialog
      open={open}
      currentId={currentId}
      onClose={onClose}
      onSelect={(id) => onSelect(id)}
      nadpis={nadpis}
    />
  );
}
